import QuestionApplicationModel from '@/dex-shared/models/QuestionApplicationModel';

export default {
  questionApplicationsByQuestionId: (state: any, getters: any) => (
    questionId: number,
  ) => {
    return Object.values(state.question_applications)
      .map(
        questionApplication =>
          new QuestionApplicationModel(questionApplication, getters),
      )
      .filter(
        questionApplication => questionApplication.questionId === questionId,
      );
  },
};
